var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CodesHistoryPanel',{attrs:{"include-doorphone-address":true,"temp-route":"ReportTempCodeProvisionHistory","service-route":"ReportServiceDoorCodeHistory"}})
}
var staticRenderFns = []

export { render, staticRenderFns }